import { QueryFactory } from "../../../../Common";
export const QGetEventsBySportId = QueryFactory("GetEventsBySportId");
//# sourceMappingURL=QGetEventsBySportId.js.map